import {useState} from 'react';
import {useWorkflowCounts} from '../../services/workflow';
import { useNavigate, useLocation } from 'react-router-dom';

const navItems = [
 {section:'Tableau de bord',items:[{path:'/dashboard',label:'Tableau de bord'}]},
 {section:'Déclarations FPT',collapsible:true,items:[
 {path:'/declarations/predeclarations',label:'Pré-déclarations',count:'predeclarations'},
 {path:'/declarations/drafts',label:'Brouillons',count:'drafts'},
 {path:'/declarations/submitted',label:'Soumises',count:'submitted'},
 {path:'/declarations/validated',label:'Validées',count:'validated'}]},
 {section:'Taxation',items:[{path:'/justifications',label:'Écarts & justifications',count:'justifications'},{path:'/taxations',label:'Taxations',count:'taxations'},{path:'/fpt/debit-notes',label:'Notes de débit',count:'debit-notes'}]},
 {section:'Paiements',collapsible:true,items:[{path:'/payments/to-pay',label:'À payer',count:'to-pay'},{path:'/payments/in-progress',label:'En cours',count:'in-progress'},{path:'/payments/paid',label:'Effectués',count:'paid'},{path:'/payments/proofs',label:'Preuves de paiement',count:'proofs'}]},
 {section:'Documents',items:[{path:'/fpt/quittances',label:'Quittances / Quitus',count:'receipts'}]},
 {section:'Établissements',items:[{path:'/establishments',label:'Mes établissements'},{path:'/licenses',label:'Licences'},{path:'/renewals',label:'Renouvellements'}]},
 {section:'Mon espace',items:[{path:'/dossier',label:'Mon dossier FPT'},{path:'/history',label:'Historique'},{path:'/reports',label:'Mes rapports'}]},
 {section:'Communication',items:[{path:'/messages',label:'Messages'},{path:'/video',label:'Vidéoconférence'}]},
 {section:'Paramètres',items:[{path:'/settings',label:'Paramètres'}]},
];
const pageTitles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/suivi-fpt': 'Suivi FPT',
 '/traceability': 'Traçabilité FPT',
  '/dossier': 'Mon dossier FPT',
  '/declarations': 'Déclarations',
  '/month-end': 'Déclarations mensuelles FPT',
  '/fpt/debit-notes': 'Notes de débit',
  '/payments': 'Paiements',
  '/fpt/quittances': 'Quittances',
  '/establishments': 'Mes établissements',
  '/licenses': 'Licences',
  '/renewals': 'Renouvellements',
  '/messages': 'Messages',
  '/video': 'Vidéoconférence',
  '/history': 'Historique',
  '/reports': 'Rapports',
  '/settings': 'Paramètres',
};

interface Props {
  ownerName: string;
  establishmentCount: number;
  onLogout: () => void;
  children: React.ReactNode;
}

export default function Sidebar({ ownerName, establishmentCount, onLogout, children }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const title = navItems.flatMap(s=>s.items).find(i=>i.path===location.pathname)?.label || pageTitles[location.pathname] || 'Portail Assujetti';
  const {counts,error:countsError}=useWorkflowCounts();
  const [collapsed,setCollapsed]=useState<Record<string,boolean>>({});


  const toggleMenu = () => {
    document.getElementById('side')?.classList.toggle('open');
  };

  const goTo = (path: string) => {
    navigate(path);
    document.getElementById('side')?.classList.remove('open');
  };

  return (
    <div className="app">
      <aside className="side" id="side">
        <div className="brand">
          <div className="logo">FPT</div>
          <div>
            <h1>Portail Assujetti V4</h1>
            <small>FPT &amp; Licences</small>
          </div>
        </div>

        {navItems.map(section => (
          <div key={section.section}>
            {section.collapsible?<button className="nav-title" aria-expanded={!collapsed[section.section]} onClick={()=>setCollapsed(c=>({...c,[section.section]:!c[section.section]}))}>{section.section} {collapsed[section.section]?'▸':'▾'}</button>:<div className="nav-title">{section.section}</div>}
            {!collapsed[section.section]&&section.items.map(item => (
              <button key={item.path} className={`nav-btn${location.pathname===item.path?' active':''}`} aria-current={location.pathname===item.path?'page':undefined} onClick={()=>goTo(item.path)}>
                {item.label} {'count' in item&&item.count&&Number(counts[item.count])>0&&<span className="nav-count">{counts[item.count]}</span>}
              </button>
            ))}
          </div>
        ))}
        {countsError&&<small role="status">{countsError}</small>}
        <div className="userbox">
          <strong>{ownerName}</strong><br />
          <small>Propriétaire · {establishmentCount} établissement{establishmentCount !== 1 ? 's' : ''}</small>
        </div>
      </aside>

      <div className="main-area">
        <header className="top">
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <button className="menu-toggle" onClick={toggleMenu}>&#9776;</button>
            <div>
              <strong>{title}</strong>
              <div className="sub">Compte Assujetti</div>
            </div>
          </div>
          <div className="top-actions">
            <button className="btn" onClick={onLogout}>Déconnexion</button>
          </div>
        </header>
        <div className="content">
          {children}
        </div>
      </div>
    </div>
  );
}
